export class ColorInputHelper {
  static handleColorInputChange = (inputValue: string, onColorChange: (color: string) => void) => {
    const trimmedValue = inputValue.trim();

    if (!trimmedValue) {
      onColorChange("transparent");
      return;
    }

    const rgbaRegex = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(0|1|0?\.\d+))?\s*\)$/i;
    if (rgbaRegex.test(trimmedValue)) {
      onColorChange(trimmedValue);
      return;
    }

    let hexValue = trimmedValue;
    if (!hexValue.startsWith("#")) {
      hexValue = `#${hexValue}`;
    }

    const hexRegex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{4}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/;
    if (hexRegex.test(hexValue)) {
      const rgbaColor = ColorInputHelper.hexToRgba(hexValue);
      if (rgbaColor) {
        onColorChange(rgbaColor);
      }
    }
  };

  static hexToRgba = (hex: string): string | null => {
    hex = hex.replace("#", "");

    let r: number;
    let g: number;
    let b: number;
    let a: number = 1;

    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 4) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
      a = parseInt(hex[3] + hex[3], 16) / 255;
    } else if (hex.length === 6) {
      r = parseInt(hex.substr(0, 2), 16);
      g = parseInt(hex.substr(2, 2), 16);
      b = parseInt(hex.substr(4, 2), 16);
    } else if (hex.length === 8) {
      r = parseInt(hex.substr(0, 2), 16);
      g = parseInt(hex.substr(2, 2), 16);
      b = parseInt(hex.substr(4, 2), 16);
      a = parseInt(hex.substr(6, 2), 16) / 255;
    } else {
      return null;
    }

    return `rgba(${r}, ${g}, ${b}, ${a})`;
  };

  static getOpacityFromColor = (color: string): number => {
    if (!color) return 100;
    const rgba = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    if (rgba && rgba[4]) {
      return Math.round(parseFloat(rgba[4]) * 100);
    }
    return 100;
  };

  static updateColorOpacity = (color: string, opacity: number): string => {
    if (!color) return color;

    const rgba = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    if (rgba) {
      const [, r, g, b] = rgba;
      return `rgba(${r}, ${g}, ${b}, ${opacity / 100})`;
    }
    return color;
  };
}
